/*
 *
 * custom components
 *
 * start
 *
 */

import ConsoleService from './consoleServiceModules/ConsoleService';

import ConsoleServiceIndexedDbModuleSettingsComponent from "./consoleServiceModules/ConsoleServiceIndexedDbModuleSettingsComponent";

import { indexed_db_name, indexed_db_version } from '../IndexedDbComponent';

/*
 *
 * custom components
 *
 * stop
 *
 */

const execute = (payload) => {

    let flag_console_log = ConsoleServiceIndexedDbModuleSettingsComponent;

    ConsoleService('', flag_console_log);
    ConsoleService('IndexedDbSettingsUpdateComponent', flag_console_log);

    ConsoleService('IndexedDbSettingsUpdateComponent / payload', flag_console_log);
    ConsoleService(payload, flag_console_log);

    let idb_name = indexed_db_name;

    ConsoleService('IndexedDbSettingsUpdateComponent / IndexedDb / idb name', flag_console_log);
    ConsoleService(idb_name, flag_console_log);

    let version = indexed_db_version;

    ConsoleService('IndexedDbSettingsUpdateComponent / IndexedDb / version', flag_console_log);
    ConsoleService(version, flag_console_log);

    return new Promise(
        (resolve, reject) => {

            ConsoleService('IndexedDbSettingsUpdateComponent / new promise', flag_console_log);

            let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

            /*
             *
             * request
             *
             * start
             * 
             */

            let request = indexedDB.open(idb_name, version);

            /*
             * request / on success / callback
             *
             * start
             * 
             */

            request.onsuccess = function (event) {

                ConsoleService('IndexedDbSettingsUpdateComponent / request / on success', flag_console_log);

                ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / event', flag_console_log);
                ConsoleService(event, flag_console_log);

                let db = event.target.result;

                /*
                 *
                 * transaction
                 *
                 * start
                 * 
                 */

                /*
                 *
                 * transaction
                 * 
                 * open a read/write db transaction, ready for adding the data
                 * 
                 * https://developer.mozilla.org/en-US/docs/Web/API/IDBDatabase/transaction
                 * 
                 */

                let transaction = db.transaction(['settings_object_store'], 'readwrite');

                ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / transaction', flag_console_log);
                ConsoleService(transaction, flag_console_log);

                /*
                 * report on the success of opening the transaction
                 */

                transaction.oncomplete = function (event) {

                    ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / transaction / on complete', flag_console_log);

                    ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / transaction / on complete / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    // !! SHOULD THE "RESOLVE" EVENT BE HERE ? !!

                    resolve(event);

                }

                transaction.onerror = function (event) {

                    ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / transaction / on error', flag_console_log);

                    ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / transaction / on error / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    reject(event);

                }

                /*
                 *
                 * transaction
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * object store
                 *
                 * start
                 * 
                 */

                let objectStore = transaction.objectStore('settings_object_store');

                ConsoleService('store', flag_console_log);
                ConsoleService(objectStore, flag_console_log);

                ConsoleService('IndexedDbSettingsUpdateComponent / objectStore.indexNames', flag_console_log);
                ConsoleService(objectStore.indexNames, flag_console_log);

                ConsoleService('IndexedDbSettingsUpdateComponent / objectStore.keyPath', flag_console_log);
                ConsoleService(objectStore.keyPath, flag_console_log);

                ConsoleService('IndexedDbSettingsUpdateComponent / objectStore.name', flag_console_log);
                ConsoleService(objectStore.name, flag_console_log);

                ConsoleService('IndexedDbSettingsUpdateComponent / objectStore.transaction', flag_console_log);
                ConsoleService(objectStore.transaction, flag_console_log);

                ConsoleService('IndexedDbSettingsUpdateComponent / objectStore.autoIncrement', flag_console_log);
                ConsoleService(objectStore.autoIncrement, flag_console_log);

                /*
                 *
                 * object store request "objectStoreRequest"
                 *
                 * start
                 * 
                 */

                var item = {

                    // set the PK
                    settings_object_store_id: payload.settings_object_store_id,

                    group: payload.group,
                    key: payload.key,
                    value: payload.value,

                };

                ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / item', flag_console_log);
                ConsoleService(item, flag_console_log);

                /*
                * we need to save the data
                * the settings data will be updated
                */

                let objectStoreRequest = objectStore.put(item);

                /*
                 *
                 * objectStoreRequest / on success
                 *
                 * start
                 * 
                 */

                objectStoreRequest.onsuccess = function (event) {

                    ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / objectStoreRequest / on success', flag_console_log);

                    ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / objectStoreRequest / on success / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    // !! SHOULD THE "RESOLVE" EVENT BE HERE ? !!

                    //resolve(event);

                }

                /*
                 *
                 * objectStoreRequest / on success
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * objectStoreRequest / on error
                 *
                 * start
                 * 
                 */

                objectStoreRequest.onerror = function (event) {

                    ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / objectStoreRequest / on error', flag_console_log);

                    ConsoleService('IndexedDbSettingsUpdateComponent / request / on success / objectStoreRequest / on error / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    reject(event);

                }

                /*
                 *
                 * objectStoreRequest / on error
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * object store request "objectStoreRequest"
                 *
                 * stop
                 * 
                 */

            }

            /*
             * request / on success / callback
             *
             * stop
             * 
             */

            /*
             * request / on error / callback
             *
             * start
             * 
             */

            request.onerror = function (event) {

                ConsoleService('IndexedDbSettingsUpdateComponent / request / on error', flag_console_log);

                ConsoleService('IndexedDbSettingsUpdateComponent / request / on error / event', flag_console_log);
                ConsoleService(event, flag_console_log);

                reject(event);

            }

            /*
             * request / on error / callback
             *
             * stop
             * 
             */

        }
    ).then(
        (data) => {

            ConsoleService('IndexedDbSettingsUpdateComponent / new promise => then', flag_console_log);

            ConsoleService('IndexedDbSettingsUpdateComponent / new promise => then / data', flag_console_log);
            ConsoleService(data, flag_console_log);

            return data;

        }
    ).catch(
        (data) => {

            ConsoleService('IndexedDbSettingsUpdateComponent / new promise => catch', flag_console_log);

            ConsoleService('IndexedDbSettingsUpdateComponent / new promise => catch / data', flag_console_log);
            ConsoleService(data, flag_console_log);

            return data;

        }
    );

    // !!! CAUTION !!! unreacheble code, because of return !!!

}

export default execute;